import { Platform } from "react-native"

export const isPlatformNative = (): boolean =>
    Platform.OS === "android" || Platform.OS === "ios"
